"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { resolveVinteraTopNavigationContext } from "../../lib/ui/navigationContext";
import PublicAccessLinks from "./PublicAccessLinks";

export default function Navbar() {
  const pathname = usePathname();
  const context = resolveVinteraTopNavigationContext(pathname);
  const logoHref = context === "customer_portal" ? "/portal" : context === "staff_workspace" ? "/admin" : "/";
  const links = context === "public" ? [
    { href: "/about", label: "About" },
    { href: "/contact", label: "Contact" },
  ] : context === "customer_portal" ? [{ href: "/portal/help", label: "Contact" }] : [];

  return (
    <nav className="sticky top-0 z-30 border-b border-[var(--vintera-border)] bg-white">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-2.5 sm:px-6">
        <Link href={logoHref} aria-label={context === "staff_workspace" ? "Vintera staff dashboard" : context === "customer_portal" ? "Vintera customer portal" : "Vintera Health home"} className="flex min-h-11 shrink-0 items-center">
          <Image
            src="/vintera-logo.jpg"
            alt="Vintera Health"
            width={1206}
            height={344}
            loading="eager"
            className={context === "customer_portal" ? "h-auto w-[207px] sm:w-[249px]" : "h-auto w-[138px] sm:w-[166px]"}
          />
        </Link>

        <div className="flex w-full min-w-0 flex-wrap items-center justify-between gap-x-2 gap-y-2 text-sm font-semibold text-[var(--vintera-muted)] sm:w-auto sm:justify-end sm:gap-x-5">
          {links.map((link) => (
            <Link key={link.href} href={link.href} className="inline-flex min-h-11 items-center transition hover:text-[var(--vintera-navy)]">
              {link.label}
            </Link>
          ))}
          <PublicAccessLinks />
        </div>
      </div>
    </nav>
  );
}
